var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-10" },
          [
            _c("b-form-input", {
              staticClass: "o-form",
              attrs: {
                id: "name-input",
                type: "text",
                required: "",
                placeholder: _vm.localPlaceholder
              },
              nativeOn: {
                blur: function($event) {
                  return _vm.leftInput($event)
                }
              },
              model: {
                value: _vm.localText,
                callback: function($$v) {
                  _vm.localText = $$v
                },
                expression: "localText"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:void(0)" },
              on: { click: _vm.deleteClicked }
            },
            [_c("icon", { attrs: { name: "trash-o" } })],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90f6e7ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90f6e7ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/music/MusicComponent.vue
// module id = null
// module chunks = 